import React from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { textSize, Points, marginLevel } from '@styles';
import { useTranslations } from '@libs/translations';
import { Card } from '../Gallery-Page/organism';

export const SimilarProjects = ({ projects = [] }) => {
  const translations = useTranslations();

  return (
    <Container>
      <Wrapper>
        <Content>
          <Title>{translations.t('site.galleryProjects.similar')}</Title>
          <Items>
            {projects && projects.map((project) => (
              <Item key={project.id}>
                <Card project={project}/>
              </Item>
            ))}
          </Items>
        </Content>
      </Wrapper>
    </Container>
  );
};

const Container = styled.section`
  padding-top: 12vw;

  @media ${Points.laptop} {
    padding-top: 7vw;
  }
`;

const Wrapper = styled.div`
  position: relative;
  background-color: ${Colors.dark_cream};
`;

const Content = styled.div`
  ${Grid.post(2)};
  ${Grid.push(2)};
  position: relative;
  z-index: 2;
  max-width: 1440px;
`;

const Title = styled.h2`
  ${textSize('h2')};
  ${marginLevel('bottom', 'dark_cream')};
  position: relative;
  z-index: 1;
`;

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -20px;
`;

const Item = styled.div`
  width: 100%;
  padding: 0 20px;
  margin-bottom: 40px;
  
  @media ${Points.tablet_portrait} {
    ${Grid.column(1, 2)};
  }
  
  @media ${Points.tablet_landscape} {
    ${Grid.column(1, 3)};
    
    &:nth-child(4) {
      display: none;
    }
  }
`;
